import { sum, round } from "mathjs";
import type { AnnualConst } from "../algorithm.types";

type CalculateTotalAnnualCostParams = {
  annualConst: Pick<AnnualConst, "annualTechCost"> & { annualDemand: number };
};

export default function calculateTotalAnnualCost({
  annualConst,
}: CalculateTotalAnnualCostParams): number {
  // Total Annual Cost (£/MWh) = Sum all technologies { Annual Cost for each Tech (£M) } / Annual Demand (TWh)
  return round(sum(annualConst.annualTechCost) / annualConst.annualDemand, 2);
}
